export const reducer = (state, action) => {
  switch (action.type) {
    case "SET_STUDENTS":
      return { ...state, students: action.payload };
    case "SET_IS_INVITING":
      return { ...state, isInviting: action.payload };
    case "SET_CREATED_CHILDS":
      return { ...state, createdChilds: action.payload };
    case "SET_INDEX_REF":
      return { ...state, indexRef: action.payload };
    case "UPDATE_STATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
